import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import { Button, InputAdornment, TextField } from "@mui/material";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import "react-notifications/lib/notifications.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import PersonIcon from "@mui/icons-material/Person";
import { loginContext } from "../context/contexts";
import { getobj } from "../apicall/apicall";
import Cookies from "js-cookie";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export default function Login() {
  const [email, setemail] = useState();
  const [open, setopen] = useState(false);
  const [credential, setcredential] = useState({ username: "", password: "" });
  const [show, setshow] = useState(false);
  //const [changepwd,setchangepwd]=useState(false)

  //console.log(Cookies.get(), "cookie");

  const handleemailChange = (e) => {
    setemail(e.target.value);
  };
  const handlepwdclick = async (email) => {
    const url = process.env.REACT_APP_ZEWA_URL + "user/forgot-password/";
    await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": Cookies.get("csrftoken"),
      },
      method: "POST",
      body: JSON.stringify({ email: email.trim().toLowerCase() }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data["Message"] === "Password changed successfully") {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success(
            "New password sent to your mail.",
            "Password Updated",
            2000,
          );
          setopen(false);
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error(
            "Please try again with correct mail.",
            "Failed",
            2000,
          );
        }
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setcredential({
      ...credential,
      [name]: value,
    });
  };

  let history = useNavigate();

  const con = useContext(loginContext);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!credential.username && !credential.password) {
      NotificationManager.remove(NotificationManager.listNotify[0]);
      NotificationManager.error(
        "Please enter username and password",
        "Failed",
        3000,
      );
      return;
    } else if (!credential.username) {
      NotificationManager.remove(NotificationManager.listNotify[0]);
      NotificationManager.error("Please enter username", "Failed", 3000);
      return;
    } else if (!credential.password) {
      NotificationManager.remove(NotificationManager.listNotify[0]);
      NotificationManager.error("Please enter password", "Failed", 3000);
      return;
    }

    let url = process.env.REACT_APP_ZEWA_URL + "user/login/";
    await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": Cookies.get("csrftoken"),
      },
      method: "POST",
      credentials: "include",

      body: JSON.stringify({
        username: credential.username.trim().toLowerCase(),
        password: credential.password.trim(),
      }),
    })
      .then(function (res) {
        if (res.status === 200) {
          return res.json();
        } else if (
          res.status === 400 ||
          res.status === 401 ||
          res.status === 403 ||
          res.status === 404
        ) {
          NotificationManager.remove(NotificationManager.listNotify[0]);
          NotificationManager.error(
            "Incorrect Username or Password, Please try again!",
            "Failed",
            3000,
          );
          throw new Error("Unauthorized: Wrong credentials");
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);
          NotificationManager.error("Wrong Credential.", "Failed", 3000);
          throw new Error(`Login failed with status ${res.status}`);
        }
      })
      .then(function (data) {
        if (!data || !data.token) {
          NotificationManager.remove(NotificationManager.listNotify[0]);
          NotificationManager.error(
            "Invalid response from server.",
            "Failed",
            3000,
          );
          throw new Error("No token in response");
        }
        sessionStorage.setItem("token", data.token);
        if (data.password_changed === false) {
          sessionStorage.setItem("id", data.user_id);
          history({ pathname: "/password-change" });
        } else if (data.role === "ADMIN") {
          history({ pathname: "/admin" });
          localStorage.setItem("role", "ADMIN");
          sessionStorage.setItem("admin_id", data.user_id);
        } else if (data.role === "CUSTOMER") {
          con.setcustomer_id(data.user_id);
          sessionStorage.setItem("customer_id", data.user_id);
          history({ pathname: "/customer" });
          localStorage.setItem("role", "CUSTOMER");
        } else if (data.role === "DISTRIBUTOR") {
          sessionStorage.setItem("customer_id", data.user_id);
          history({ pathname: "/distributor" });
          localStorage.setItem("role", "DISTRIBUTOR");
        } else if (data.role === "DISTRIBUTOR-USER") {
          const url =
            process.env.REACT_APP_ZEWA_URL +
            "user/get-customer/" +
            data.user_id +
            "/";
          const d = getobj(url);
          d.then(function (res) {
            con.setcustomer_id(res.data.friends[0]);
            sessionStorage.setItem("customer_id", res.data.friends[0]);
            sessionStorage.setItem("user_id", data.user_id);
            history({ pathname: "/distributor-user" });
            localStorage.setItem("role", "DISTRIBUTOR-USER");
            //console.log(res.friends[0])
          });
        } else {
          const url =
            process.env.REACT_APP_ZEWA_URL +
            "user/get-customer/" +
            data.user_id +
            "/";
          const d = getobj(url);
          d.then(function (res) {
            con.setcustomer_id(res.data.friends[0]);
            sessionStorage.setItem("customer_id", res.data.friends[0]);
            sessionStorage.setItem("user_id", data.user_id);
            history({ pathname: "/user" });
            //console.log(res.friends[0])
            localStorage.setItem("role", "USER");
          });
        }
      })
      .catch(function (error) {
        console.error("Login error:", error);
        // Error is already handled in .then() blocks
        // This catch is just to prevent unhandled rejection errors
      });
  };

  return (
    <div>
      <Box
        sx={{
          boxShadow: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          padding: "1rem",
          backgroundColor: "#f5f5f5",
        }}
      >
        <Box
          sx={{
            boxShadow: "0px 3px 6px rgba(0,0,0,0.1)",
            width: "100%",
            maxWidth: "450px",
            padding: "2.5rem",
            fontFamily: "Roboto",
            fontSize: "clamp(20px, 5vw, 26px)",
            backgroundColor: "#ffffff",
            borderRadius: "8px",
          }}
        >
          <div>
            <small style={{ fontSize: "clamp(14px, 3vw, 16px)" }}>
              <b>Sign in to RPM Pro portal</b>
            </small>
          </div>

          <br />
          <form
            onSubmit={(e) => {
              handleSubmit(e);
            }}
          >
            <div>
              <TextField
                id="outlined-basic"
                label="Enter Email"
                variant="outlined"
                name="username"
                fullWidth
                sx={{
                  marginTop: "1rem",
                  maxWidth: "100%",
                  "& .MuiOutlinedInput-root": {
                    fontSize: "clamp(12px, 2.5vw, 16px)",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(0, 0, 0, 0.23)",
                  },
                  "& .MuiInputLabel-outlined": {
                    transform: "translate(14px, 20px) scale(1)",
                  },
                  "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                    transform: "translate(14px, -9px) scale(0.75)",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <PersonIcon />
                    </InputAdornment>
                  ),
                }}
                value={credential.username}
                onChange={(e) => {
                  handleChange(e);
                }}
              />
            </div>
            <br />

            <div>
              <TextField
                id="outlined-basic"
                label="Enter password"
                type={show ? "text" : "password"}
                variant="outlined"
                fullWidth
                sx={{
                  marginTop: "1rem",
                  maxWidth: "100%",
                  "& .MuiOutlinedInput-root": {
                    fontSize: "clamp(12px, 2.5vw, 16px)",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(0, 0, 0, 0.23)",
                  },
                  "& .MuiInputLabel-outlined": {
                    transform: "translate(14px, 20px) scale(1)",
                  },
                  "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                    transform: "translate(14px, -9px) scale(0.75)",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                name="password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {show ? (
                        <VisibilityOff
                          onClick={() => {
                            setshow(false);
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      ) : (
                        <Visibility
                          onClick={() => {
                            setshow(true);
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      )}
                    </InputAdornment>
                  ),
                }}
                value={credential.password}
                onChange={(e) => {
                  handleChange(e);
                }}
              />
            </div>
            <br />
            <Grid container>
              <Grid item xs>
                <Link
                  href="#"
                  variant="body2"
                  onClick={() => {
                    setopen(true);
                  }}
                  sx={{ fontSize: "clamp(12px, 2.5vw, 14px)" }}
                >
                  Forgot password?
                </Link>
              </Grid>
            </Grid>
            <br />
            <div>
              <Button
                type="submit"
                color="primary"
                variant="contained"
                className="form__custom-button"
                fullWidth
                sx={{
                  marginTop: "1rem",
                  padding: "clamp(0.5rem, 2vw, 0.75rem)",
                  fontSize: "clamp(12px, 2.5vw, 16px)",
                }}
              >
                SIGN IN
              </Button>
            </div>
            <br />
          </form>
        </Box>
      </Box>
      <Dialog
        open={open}
        onClose={() => {
          setopen(false);
        }}
        PaperProps={{
          sx: {
            minWidth: "clamp(250px, 90vw, 400px)",
          },
        }}
      >
        <DialogTitle sx={{ fontSize: "clamp(16px, 3vw, 20px)" }}>
          Forgot Password
        </DialogTitle>
        <DialogContent>
          <TextField
            id="name"
            label="Enter Email"
            type="email"
            variant="standard"
            fullWidth
            sx={{
              marginTop: "1rem",
              "& .MuiInput-root": {
                fontSize: "clamp(12px, 2.5vw, 16px)",
              },
            }}
            onChange={handleemailChange}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            sx={{ fontSize: "clamp(12px, 2.5vw, 14px)" }}
            onClick={() => {
              handlepwdclick(email);
            }}
          >
            Send
          </Button>
          <Button
            variant="contained"
            color="error"
            sx={{ fontSize: "clamp(12px, 2.5vw, 14px)" }}
            onClick={() => {
              setopen(false);
            }}
          >
            cancel
          </Button>
        </DialogActions>
      </Dialog>

      <NotificationContainer />
    </div>
  );
}
